export default __webpack_public_path__ + "static/media/caera-mockup-mobile.7af88cde.png";